import { defineMessages } from 'react-intl'

const scope = `procurify.platform.iam.feature-sets.ReportAccessView.ReportAccessSubmitActionSelect`

export default defineMessages({
  ariaLabel: {
    id: `${scope}.ariaLabel`,
    defaultMessage: 'Action',
  },
  addOptionLabel: {
    id: `${scope}.addOptionLabel`,
    defaultMessage: 'Add',
  },
  removeOptionLabel: {
    id: `${scope}.removeOptionLabel`,
    defaultMessage: 'Remove',
  },
})
